import { CheckboxOptionType } from 'antd/lib/checkbox';
import { DriverWorkflow } from 'providence-types';

export const WORKFLOW_OPTIONS: CheckboxOptionType[] = Object.values(
  DriverWorkflow,
).map((value: string) => ({ label: value.replace('_', ' '), value }));
